import { Component, OnInit } from '@angular/core';
import { PermitDetailsModel, PermitService, PermitDetailsBillingItemModel, BillingDetailsResponseData } from '../services/permit.service';
import { ErrorHandlingService, LocalParserFormatter } from 'core-lib';
import { ListComponentBase, ListViewModelBase, FilterBase } from 'core-lib';
import * as _ from 'lodash';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { AuthorizeService } from 'projects/core-lib/src/public-api';

@Component({
  selector: 'cli-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.scss']
})
export class BillingListComponent extends ListComponentBase implements OnInit {

  public vm: BillingViewModel;

  constructor(private permitSvc: PermitService,
    private errorHandlingSvc: ErrorHandlingService,
    private authorizeService: AuthorizeService,
    private formatter: LocalParserFormatter) {
    super();
    this.vm = new BillingViewModel();
  }

  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitSvc.model;

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.mapModel(this.vm, data);

      this.vm.isLoading = false;
      this.vm.isOpening = false;
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });
  }

  public downloadCsv(id: string) {

    window.open(environment.apiURL + 'client/billing-transactions-csv?id=' + id + '&userId=' + this.authorizeService.userId, '_self');
  }


  loadList(): Promise<void> {
    this.vm.isLoading = true;
    return this.permitSvc.getBilling(this.vm.filter).toPromise()
      .then((data: BillingDetailsResponseData) => {

        this.vm.totalCount = data.totalCount;
        this.vm.items = _.map(data.items, (b: PermitDetailsBillingItemModel) => {
          return this.mapItem(b);
        });
      },
        (e) => {
          let errorMessage = this.errorHandlingSvc.processHttpError(e);
          return Promise.reject(errorMessage);
        })
      .finally(() => { this.vm.isLoading = false; });
  }

  mapModel(vm: BillingViewModel, data: PermitDetailsModel) {
    vm.businessName = data.permitDetails.clientName;
    vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName;
    vm.permitNo = data.permitDetails.permitNo;

    vm.totalCount = data.billingPeriodsCount;
    vm.items = _.map(data.billingPeriods, (b: PermitDetailsBillingItemModel) => {
      return this.mapItem(b);
    });
  }

  mapItem(b: PermitDetailsBillingItemModel): BillingPeriodListViewModel {
    let bm = new BillingPeriodListViewModel();
    bm.periodName = moment(b.endDate).format('MMMM YYYY');
    bm.cost = b.permitFee + b.loggerUsage + b.emsUsage + b.manualUsage;
    bm.deviceCost = b.loggerUsage;
    bm.manualCost = b.manualUsage;
    bm.emsCost = b.emsUsage;
    bm.permitCost = b.permitFee;
    bm.isExpanded = false;
    bm.billingPeriodId = b.billingPeriodId;
    return bm;
  }
}
export class BillingViewModel extends ListViewModelBase {
  constructor() {
    super();
    this.items = [];
    this.filter = new BillingFilter();
  }


  public isOpening: boolean;
  public isLoading: boolean;
  public businessName: string;
  public contactName: string;
  public permitNo: string;

  public filter: BillingFilter;
  public items: BillingPeriodListViewModel[];
}
export class BillingPeriodListViewModel {
  public periodName: string;
  public permitCost: number;
  public cost: number;
  public emsCost: number;
  public deviceCost: number;
  public manualCost: number;
  public isExpanded: boolean;
  public billingPeriodId: string;
}

export class BillingFilter extends FilterBase {

  constructor() {
    super();
    this.take = 20;
    this.skip = 0;
  }


}
